import { Component,OnInit } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { HttpClient,HttpResponse } from '@angular/common/http';
import { Storage } from '@ionic/storage';

//types
import { Offer,LoginInfo } from '../model/types';

//service
import { AppSharedService  } from '../service/app_shared';

//page
import { MenuPage } from '../menu/menu'
import { LoginPage } from '../login/login';

@Component({
  selector: 'page-offer',
  templateUrl: 'offer.html',
})
export class OfferPage implements OnInit{

  //class variable
  offerList:Offer[];

  //constructor
  constructor(public navCtrl: NavController
    , public navParams: NavParams
    , private http: HttpClient
    , private storage: Storage
    , private appSharedService:AppSharedService
    , private loadingCtrl : LoadingController
  ) {
    
    //initialize class variable
    this.offerList=[];
  }
  
  //initialization
    ngOnInit(){
      this.getOfferDetails();
    }
    goToHome(){
      this.navCtrl.popToRoot();
      this.navCtrl.setRoot(MenuPage)
    }
    //get offer details
    getOfferDetails(){
          //create loader
          let loading = this.loadingCtrl.create({
            content: 'Please wait...'
          });
      
      this.storage.get("bz_user_02").then((userinfo:LoginInfo) => {

      if(userinfo!=undefined && userinfo!=null && userinfo.Token!=undefined){

        // show loader
        loading.present();

        var url=(this.appSharedService.configInfo.applicationInfo.apiBasePath+'/'+this.appSharedService.configInfo.urlInfo.urlGetOfferList);
    
        this.http.get(url+'/'+userinfo.LocationId,{observe:'response'})
        .subscribe((res: HttpResponse<any>) => {   
          if(res.status==200){
            if(res.body!=undefined && res.body!=null){
                   this.offerList= res.body as Offer[];
                   loading.dismiss();
            }
          }
          else if(res.status==204){
            loading.dismiss();
            this.storage.clear();
            this.navCtrl.popToRoot();
            this.navCtrl.setRoot(LoginPage);
          }
          else{
            loading.dismiss();
          }
        });
      }
  });
 }
}


// WEBPACK FOOTER //
// ./src/pages/offer/offer.ts